import _ from 'lodash';
import { toNumber } from '../functions';
import {
    FETCH_MTOKNA_SELLER_COMPLAINTS,
    CLEAN_MTOKNA_SELLER_COMPLAINTS,
    CHANGE_MTOKNA_SELLER_COMPLAINT_STATE,
} from '../actions/types';

const MTOKNA_SELLER_COMPLAINTS_DEFAULT_STATE = {};

const MtoknaSellerComplaintsReducer = (state = MTOKNA_SELLER_COMPLAINTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_SELLER_COMPLAINTS:
            return payload;

        case CLEAN_MTOKNA_SELLER_COMPLAINTS:
            return MTOKNA_SELLER_COMPLAINTS_DEFAULT_STATE;

        case CHANGE_MTOKNA_SELLER_COMPLAINT_STATE:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, status: payload.status, data: { ...item.data, ...payload.data } };
                }

                return item;
            }) };

        default:
            return state;
    }
};

export default MtoknaSellerComplaintsReducer;
